// Toyo Family configuration - Family-friendly games
import { AppConfig } from './types';
import { familyTheme } from './themes';
import { FAMILY_GAMES } from './games';

export const familyConfig: AppConfig = {
  // App identity
  appId: 'family',
  appName: 'Toyo Family',
  appTagline: 'Play. Bond. Grow.',
  
  // Branding
  logo: '/assets/toyo-family-logo.png',
  homeUrl: 'https://toyo.games/family',
  
  // Theme
  theme: familyTheme,
  
  // Games - Family has age-appropriate games for all ages
  games: FAMILY_GAMES,
  
  // Feature flags
  features: {
    voting: true,
    hostPlaying: true,
    settings: true,
  },
  
  // Storage prefix
  storagePrefix: 'toyo-family',
  
  // SEO and metadata
  seo: {
    title: 'Toyo Family - Family-Friendly Games for All Ages | family.toyo.games',
    description: 'Age-appropriate family games for kids and adults. Family Trivia, Animal Quiz, Wonder World, and more. Perfect for family game nights, kids parties, and educational fun. Safe, engaging, and entertaining for the whole family!',
    keywords: [
      'toyo family',
      'family games',
      'kids games',
      'family trivia',
      'animal quiz',
      'wonder world',
      'family game night',
      'kids party games',
      'educational games',
      'age-appropriate games',
      'family activities',
      'children games',
      'safe games for kids',
      'family entertainment',
      'kids trivia',
      'educational trivia',
      'disney trivia',
      'science games',
      'nature games',
    ],
    ogTitle: 'Toyo Family - Play. Bond. Grow.',
    ogDescription: 'Age-appropriate family games for all ages. Family Trivia, Animal Quiz, and Wonder World. Perfect for family game nights!',
    ogImage: '/assets/toyo-family-logo.png',
    ogUrl: 'https://family.toyo.games',
    twitterCard: 'summary_large_image',
    twitterTitle: 'Toyo Family - Play. Bond. Grow.',
    twitterDescription: 'Age-appropriate family games for all ages. Perfect for family game nights!',
    twitterImage: '/assets/toyo-family-logo.png',
  },
};
